import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import ConversationItem from 'models/conversation_item';
import ConversationItemMenu from '../menu/conversation_item_menu_container';
import PinnedCustomerList from 'components/customer/conversation_history/conversation_items_v2/content/pinned_customer_list';

export default class BubbleContent extends React.Component {
  render() {
    const {
      children,
      className,
      'data-aid': dataAid,
      isCollapsed,
      item,
      onClick = _.noop,
      onRef,
      status,
      hasReaction,
    } = this.props;
    if (isCollapsed) {
      return null;
    }

    const hasCommError = item.content.hasErrorStatus && item.content.hasErrorStatus();
    const isInbound = item.isInbound();
    const includeStatus = !!status;

    const classNames = classnames(
      'bubbleContent',
      {
        'bubbleContent-error': hasCommError,
        'bubbleContent-inbound': isInbound,
        'bubbleContent-outbound': !isInbound,
        'bubbleContent-withChin': item.linkedItems.length > 0,
        'bubbleContent-withReaction': hasReaction,
        [`status-${status}`]: includeStatus,
      },
      'fs-exclude',
      className
    );

    const content = (
      <div className={classNames} data-aid={dataAid} onClick={onClick} ref={!hasCommError && onRef}>
        <BubbleMenu>
          <ConversationItemMenu item={item} />
        </BubbleMenu>
        {children}
      </div>
    );

    if (hasCommError) {
      const wrapperClassNames = classnames('bubbleContent-errorWrapper', {
        'bubbleContent-errorWrapper-inbound': isInbound,
        'bubbleContent-errorWrapper-outbound': !isInbound,
      });
      return (
        <React.Fragment>
          <div className={wrapperClassNames} ref={onRef}>
            <i className="bubbleContent-errorIcon fa fa-exclamation" />
            {content}
          </div>
          <PinnedCustomerList isInbound={isInbound} item={item} />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {content}
        <PinnedCustomerList isInbound={isInbound} item={item} />
      </React.Fragment>
    );
  }
}

BubbleContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  'data-aid': PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  isCollapsed: PropTypes.bool,
  onClick: PropTypes.func,
  onRef: PropTypes.func,
  status: PropTypes.string,
  hasReaction: PropTypes.bool,
};

export function BubbleFooter({ className, children }) {
  const classNames = classnames('bubbleContent-footer', className);
  return <div className={classNames}>{children}</div>;
}

export function BubbleHeader({ className, children }) {
  const classNames = classnames('bubbleContent-header', className);
  return <div className={classNames}>{children}</div>;
}

export function BubbleMenu({ className, children }) {
  const classNames = classnames('bubbleContent-menu', className);
  return <div className={classNames}>{children}</div>;
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/content/bubble_content.jsx